import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'

;(() => {
  function isMobile () {
    let ua = navigator.userAgent;
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
        isIphone = ua.match(/(iPhone\sOS)\s([\d_]+)/),
        isAndroid = ua.match(/(Android)\s+([\d.]+)/),
        _isMobile = ipad || isIphone || isAndroid;
    return !!_isMobile;
  }
  if (!isMobile()) window.location.href = 'https://diantoushi.com';
})();

import moment from 'moment'//导入文件 
Vue.prototype.$moment = moment;//赋值使用

Vue.config.productionTip = false;
new Vue({
  render: h => h(App),
}).$mount('#app')
